module.exports = __webpack_public_path__ + "img/layout-sidebar-reverse.df8f6866.svg";